import { CachedEventRegistry } from 'app/shared/events/cached_event_registry';
import { TimeZone } from 'app/shared/time/TimeZone';

function isValid(tz: TimeZone) {
    return tz != null && tz.string;
}

export class TimeZoneManager {
    private _event: CachedEventRegistry;
    private _timeZone: TimeZone;

    /**
     * A simple store and event registry for the current time zone.
     * This class is simple as it exposes the ability to set it's state, the idea being for other
     * objects to contain the logic for when the time zone changes; and keep this class service dependency free.
     * @param timeZone An initial time zone is required to simplify the state.
     * If you don't have an initial time zone, just use the browsers time zone.
     * Having no time zone is impossible.
     */
    constructor(timeZone: TimeZone) {
        if (!isValid(timeZone)) {
            throw new Error('Invalid initial time zone');
        }
        this._timeZone = timeZone;
        this._event = new CachedEventRegistry(this._timeZone);
    }

    async setTimeZone(timeZone: TimeZone) {
        if (!isValid(timeZone)) {
            throw new Error('Invalid time zone object');
        }
        // only push an update if the time zone actually changed
        if (this._timeZone.string !== timeZone.string) {
            this._timeZone = timeZone;
            await this._event.notifyListeners(this._timeZone);
        }
    }

    getTimeZone(): TimeZone {
        return this._timeZone;
    }

    onChange(fn: (timeZone: TimeZone) => void): () => void {
        return this._event.addEventListener(fn);
    }
}
